import {PageGen, resolve_id} from './page-generator.js';

PageGen.commands.set_css_attribute = function(args) {
    const elem = resolve_id(args[0]);
    elem.css(args[1], args[2]);
};

PageGen.commands.font_size = function(args) {
    const elem = resolve_id(args[0]);
    elem.css('font-size', args[1]);
};

PageGen.commands.bg_color = function(args) {
    const elem = resolve_id(args[0]);
    elem.css('background-color', args[1]);
};

PageGen.commands.font_color = function(args) {
    const elem = resolve_id(args[0]);
    elem.css('color', args[1]);
};

PageGen.commands.font_family = function(args) {
    const elem = resolve_id(args[0]);
    elem.css('font-family', args[1]);
};

PageGen.commands.width = function(args) {
    const elem = resolve_id(args[0]);
    elem.css('width', args[1]);
};

PageGen.commands.border = function(args) {
    const elem = resolve_id(args[0]);
    elem.css('border', args[1]);
};
